import { render, staticRenderFns } from "./DatasetAsImage.vue?vue&type=template&id=c71fb252&"
import script from "./DatasetAsImage.vue?vue&type=script&lang=js&"
export * from "./DatasetAsImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports